export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Placeholder replaced with the client's number (DDD 84 + 21324872).
const WA_NUMBER = "558421324872";
export const CONTACT_EMAIL = "claudio.oliverplus@proton.me";
export const WHATSAPP_URL = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(
    "Olá, Claudio. Conheci o MasterClaus pelo site e quero solicitar um Esboço Investigativo para o meu negócio."
)}`;
export const LINKEDIN_URL = "https://www.linkedin.com/";

export const NAV_LINKS = [
    { id: "#problema", label: "O Problema", tid: "nav-link-problema" },
    { id: "#metodologia", label: "Metodologia", tid: "nav-link-metodologia" },
    { id: "#niveis", label: "Níveis", tid: "nav-link-niveis" },
    { id: "#autoridade", label: "Autoridade", tid: "nav-link-autoridade" },
];

export const scrollToSection = (selector) => {
    const el = document.querySelector(selector);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -72, duration: 1.2 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};
